// @flow
export const GET_GORGON_RUN_DATA='GET_GORGON_RUN_DATA';
export const GET_GORGON_RUN_DATA_ERROR='GET_GORGON_RUN_DATA_ERROR';
export const GET_GORGON_RESULTSET_DATA='GET_GORGON_RESULTSET_DATA';
export const GET_GORGON_RESULTSET_DATA_ERROR='GET_GORGON_RESULTSET_DATA_ERROR';
export const GET_GORGON_FORM_QUESTIONS_DATA='GET_GORGON_FORM_QUESTIONS_DATA';
export const GET_GORGON_FORM_QUESTIONS_DATA_ERROR='GET_GORGON_FORM_QUESTIONS_DATA_ERROR';
export const GET_ADM_GORGON_FORMS_DATA='GET_ADM_GORGON_FORMS_DATA';
export const GET_ADM_GORGON_FORMS_DATA_ERROR='GET_ADM_GORGON_FORMS_DATA_ERROR';
export const GET_ADM_GORGON_FORM_QUESTIONS_DATA='GET_ADM_GORGON_FORM_QUESTIONS_DATA';
export const GET_ADM_GORGON_FORM_QUESTIONS_DATA_ERROR='GET_ADM_GORGON_FORM_QUESTIONS_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/gorgon/actionTypes.js